//Constants for EQUIPMENT_SELECTION
export const EQUIPMENT_SELECTION_REQUEST = "EQUIPMENT_SELECTION_REQUEST";
export const EQUIPMENT_SELECTION_SUCCESS = "EQUIPMENT_SELECTION_SUCCESS";
export const EQUIPMENT_SELECTION_FAIL = "EQUIPMENT_SELECTION_FAIL";

//Constants for EQUIPMENT_UPDATION
export const EQUIPMENT_UPDATION_REQUEST = "EQUIPMENT_UPDATION_REQUEST";
export const EQUIPMENT_UPDATION_SUCCESS = "EQUIPMENT_UPDATION_SUCCESS";
export const EQUIPMENT_UPDATION_FAIL = "EQUIPMENT_UPDATION_FAIL";

//Constants for EQUIPMENT_DELETION
export const EQUIPMENT_DELETION_REQUEST = "EQUIPMENT_DELETION_REQUEST";
export const EQUIPMENT_DELETION_SUCCESS = "EQUIPMENT_DELETION_SUCCESS";
export const EQUIPMENT_DELETION_FAIL = "EQUIPMENT_DELETION_FAIL";
